module.exports = __webpack_public_path__ + "static/media/color_logo_transparent_snippext_api.51bd9fb7.png";